import z from 'zod';
import { objectIdRef } from '../common.js';
import { DateTimeSchema } from '../dates.js';
import { JobProfile, JobProfilePromptType } from '../llmResponseSchemas.js';
// TODO(#2203): move NO_DEPARTMENT_KEY into the shared profile module phase 2 creates
import { NO_DEPARTMENT_KEY } from './candidateProfileSchema.js';

export const IJobProfileData = z.object({
  profile: JobProfile,
  sources: objectIdRef('LlmResponse').array().describe('Contributing LlmResponse docs'),
  profileOutputHash: z.string().describe('hashObject(profile) — upsert idempotency'),
  promptType: JobProfilePromptType,
  schemaName: z.literal('JobProfile').nullish(),
  profileCreatedAt: DateTimeSchema.describe('When the source profile response was generated'),
  profileDepartmentKey: z
    .string()
    .array()
    .default([NO_DEPARTMENT_KEY])
    .describe('Department key with a default placeholder value to be indexible'),
});
export type IJobProfileData = z.infer<typeof IJobProfileData>;
